/**
 * vendeurs模块接口列表
 */

import base from './base'; // 导入接口域名列表
import axios from '../request/http'; // 导入http中创建的axios实例
// import qs from 'qs'; // 根据需求是否导入qs模块

const vendeurs = {
    //查找商家列表
    list(query) {
        return axios.get(base.dev + '/v2/vendeurs/list', {params: query});
    },
    collect(id) {
        return axios.get(base.dev + '/acheteur/produits/' + id);
    },
    vendeursProd(obj, params) {
        return axios.get(base.dev + '/vendeurs/' + obj.id_vendeur + '/produits', {params:params});
    },
    // 其他接口…………
}

export default vendeurs;
